import { type ScreenViewEvent } from '@stitch-fix/event-reporter';
import { type ComponentType } from 'react';
import { type NavProps } from '../../../../components/OnboardingNavigation/Nav';
import { type StepWrapperProps } from '../../../../components/OnboardingNavigation/StepWrapper';
import { anchor } from './flows/anchor';
import { inFlow } from './flows/in';
import { nu } from './flows/nu';
import { pi } from './flows/pi';
import { hh } from './flows/hh';
import { type FlowContext } from './flow-machine';
const flowIds = ['nu', 'anchor', 'pi', 'in', 'hh'] as const;
export type FlowId = (typeof flowIds)[number];
export const defaultFlow: FlowId = 'pi';
export const nuFlow: FlowId = 'nu';
export const anchorFlow: FlowId = 'anchor';
export type StepComponentProps = ComponentType;
export type Step = {
  step: string;
  Component: ComponentType;
  bgColor?: StepWrapperProps['bgColor'];
  navBgColor?: NavProps['bgColor'];
  hideNav?: boolean;
  showNavTitle?: boolean;
  screenViewEvent: Pick<ScreenViewEvent, 'name' | 'content_id'>;
  gutter?: StepWrapperProps['gutter'];
  restrictedBusinessLines?: FlowContext['businessLine'][];
  isVisible?: (context: FlowContext) => boolean;
};
export const flows: Record<FlowId, Step[]> = {
  nu,
  anchor,
  pi,
  in: inFlow,
  hh
};